<template>
<div>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('book.refuseReason')" center width="600px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog h100p">
          <div class="df-l-fs">
            <div class="box df-c-fs" @click="optionSelect(1)">
              <img style="width:20px;height:20px;margin-right:16px;" mode="aspectFill" :src="optionSelected===1?iconCheckok2:iconChecknull2" />
              <div class="reason-label f-dark f-m">{{$t('book.full')}}</div>
            </div>
            <div class="box df-c-fs" @click="optionSelect(2)">
              <img style="width:20px;height:20px;margin-right:16px;" mode="aspectFill" :src="optionSelected===2?iconCheckok2:iconChecknull2" />
              <div class="reason-label f-dark f-m">{{$t('book.pause')}}</div>
            </div>
            <div class="box df-c-fs" @click="optionSelect(3)">
              <img style="width:20px;height:20px;margin-right:16px;" mode="aspectFill" :src="optionSelected===3?iconCheckok2:iconChecknull2" />
              <div class="reason-label f-dark f-m">{{$t('book.otherReason')}}</div>
            </div>
            <div class="box df-c-fs" v-show="optionSelected===3">
              <input type="text" class="input f-m" :placeholder="$t('book.inputOtherReason')" v-model="reasonContent" ref="input1" @focus="onFocus_forScan" @blur="onBlur_forScan" />
            </div>
          </div>

        </div>
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="whitebtn" @click="close">{{$t('common.cancel')}}</div>
        <div class="themebtn" @click="submitClick">{{$t('common.comfirm')}}</div>
      </div>
    </div>
  </el-dialog>

</div>
</template>

<script>
export default {
  name: 'DialogRefuse',
  data() {
    return {
      isShowDialog: false,
      rowClicked: '',
      optionSelected: '',
      reasonContent: '',
    }
  },
  methods: {
    open(row) {
      this.rowClicked = row
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
    },
    optionSelect(val) {
      this.optionSelected = val
    },
    submitClick() {
      if (this.optionSelected === '' || (this.optionSelected === 3 && this.reasonContent === '')) {
        return
      }
      
      this.el_loading_x_save(true)
      let rData = {
        id: this.rowClicked.id,
        status: 2,
        refusedType: this.optionSelected,
        refusedContent: this.optionSelected === 3 ? this.reasonContent : '',
      }

      return this.setData('book', rData).then(resp => {
        this.$message.success(this.$t('common.handleSuccess'))
        this.rowClicked.status = 2

        this.el_loading_x_save(false)
        this.close()
      }).catch(res => {
        this.el_loading_x_save(false)
      })

      // this.$emit('submitDialog')
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 30px 20px 0;box-sizing: border-box;

  .box{
    position: relative;padding: 20px 0;margin: 0 60px;
    .input{width: 440px;height: 40px;padding: 0 40px 0 10px;box-sizing: border-box;}
    .icon{width: 40px;height: 40px;position: absolute;right: 0;top: 0;bottom: 0;margin: auto;}
  }
}
</style>